export enum TaskPaymentTypeEnum {
  CASH = 'CASH',
  BANK = 'BANK',
}
